import api from "../services/api";

// Fetch notifications function with optional filters
export const fetchNotifications = async (filterField, filterValue, page = 1, size = 10) => {
  try {
    const params = { page, size };
    if (filterField && filterValue) {
      params.filter_field = filterField;
      params.filter_value = filterValue;
    }

    const response = await api.get("/notification-management/notifications/me", {
      params,
    });

    if (response.status === 200) {
      const { data } = response.data;
      const { results, total, page: currentPage, size: pageSize } = data;

      const hasMore = currentPage * pageSize < total;

      return {
        notifications: results,
        total,
        hasMore,
        page: currentPage,
      };
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching notifications:", error.message || error);
    const errorMessage = error.response?.data?.detail || error.message || "Failed to fetch notifications";
    return { error: errorMessage };
  }
};




export const fetchAllNotifications = async () => {
  try {
    const response = await api.get("/notification-management/notifications");

    if (response.status === 200) {
      return response.data.data; 
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching all notifications:", error.message || error);
    const errorMessage = error.response?.data?.detail || error.message || "Failed to fetch notifications";
    return { error: errorMessage };
  }
};

// Mark a notification as "Read"
export const markNotificationAsRead = async (notificationId) => {
    try {
      // Make the API request to mark the notification as "Read"
      const response = await api.put(
        `/notification-management/notifications/${notificationId}/mark-as-read`
      );
  
      if (response.status === 200) {
        console.log("Notification marked as read", response.data);
        return response.data; // Return success response or updated notification data
      } else {
        console.warn("Unexpected Response:", response);
        return { error: "Unexpected response from server" };
      }
    } catch (error) {
      console.error("Error marking notification as read:", error.message || error);
      const errorMessage = error.response?.data?.detail || error.message || "Failed to mark notification as read";
      return { error: errorMessage };
    }
  };


  // Send a notification
export const sendNotification = async (payload) => {
  try {
    const response = await api.post(
      "/notification-management/notifications/send",
      payload
    );

    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error sending notification:", error.message || error);
    const errorMessage = error.response?.data?.detail || error.message || "Failed to send notification";
    return { error: errorMessage };
  }
};
